<script lang="ts" setup>
import { computed, inject, ref } from 'vue'
import { FireRiskDashboardViewModel } from '../../viewmodels/FireRiskDashboard.viewmodel'
import { NetworkConnectionStatusEnum } from '../../enums/NetworkConnectionStatus.enum'
import Dropdown from '@/components/ui/dropdown/Dropdown.vue'
import { Icon } from '@iconify/vue2'
import ConnectionStatusIcon from '../ConnectionStatusIcon.vue'
import Checkbox from '@/components/ui/checkbox/Checkbox.vue'
import { onClickOutside } from '@vueuse/core'

defineProps<{
	websocketStatus: NetworkConnectionStatusEnum
}>()

const options = ref()

const vm = inject<FireRiskDashboardViewModel>('fire-risk-dashboard-viewmodel')!

const opened = ref(false)

onClickOutside(options, () => (opened.value = false))

const disableChartSection = computed(() => !vm.showMapSection.value && !vm.showTableSection.value)
const disableMapSection = computed(() => !vm.showChartSection.value && !vm.showTableSection.value)
const disableTableSection = computed(() => !vm.showChartSection.value && !vm.showMapSection.value)
</script>

<template>
	<div>
		<div class="flex gap-6 items-center">
			<h1 class="text-H4 !m-0">{{ $t('fireRiskDashboardTitle') }}</h1>
			<connection-status-icon :status="websocketStatus" />
		</div>
		<div class="flex w-full justify-between items-center mt-7">
			<dropdown
				:options="vm.farms.value"
				v-model="vm.selectedFarmsIds.value"
				:label="$t('fireRiskDashboardFarmSector').toString()"
				class="w-1/4"
			/>
			<div class="relative">
				<div @click="opened = true">
					<Icon
						icon="material-symbols:settings"
						class="text-3xl text-blue-base cursor-pointer"
					/>
				</div>

				<ul
					v-if="opened"
					ref="options"
					class="border rounded border-blue-base p-2 top-1 absolute bg-white-neutral z-10 -translate-x-full translate-y-1/3 min-w-max"
				>
					<li class="ml-2">
						<checkbox
							:label="$t('fireRiskDashboardGaugeChart').toString()"
							v-model="vm.showChartSection.value"
							:disabled="disableChartSection"
						/>
					</li>
					<li class="ml-2">
						<checkbox
							:label="$t('fireRiskDashboardAlertMap').toString()"
							v-model="vm.showMapSection.value"
							:disabled="disableMapSection"
						/>
					</li>
					<li class="ml-2">
						<checkbox
							:label="$t('fireRiskDashboardExportTable').toString()"
							v-model="vm.showTableSection.value"
							:disabled="disableTableSection"
						/>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>
